import { AxiosError } from 'axios';
import { GET_PAYMENT_STATUS_URL } from "../../constants/apiUrls";
import {
 GET_PAYMENT_STATUS_QUERY_KEY
} from "../../constants/queryKeys";
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { PaymentStatus } from "../../models/PaymentStatus";
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PaymentStatusResponse {
  code: PaymentStatus;
  description: string;
}
// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: PaymentStatusResponse[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetPaymentStatus = ({ onSuccess, onError }: Input = {}) => {
  const getPaymentStatus = async () => {
    const res = await axiosClient.get<PaymentStatusResponse[]>(GET_PAYMENT_STATUS_URL);
    return res.data;
  };

  return useCustomQuery([GET_PAYMENT_STATUS_QUERY_KEY], getPaymentStatus, {
    onSuccess,
    onError,
  });
};
